import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiSessionRejectedError } from '@/core/error/transport/customErrors/tmApiSessionRejectedError'

export const sessionRejectedErrorRule: CustomErrorRule = {
  subCodes: ['messages.session.rejected'],
  klass: TmApiSessionRejectedError,
}
